module.exports = __webpack_public_path__ + "static/img/banner.0d3d3fa9.png";